// extracted by mini-css-extract-plugin
module.exports = {"shopPage":"Style_shopPage__aXJ2X","regisButton0":"Style_regisButton0__2A9yI","regisButton1":"Style_regisButton1__-4UHi"};